module.exports = __webpack_public_path__ + "img/akkodis-letter.104eaacf.svg";